export default class QaFiltersViewModel {
    isActive: boolean = false;
    monitoringStatus: string = ''
    monitoredBy: string[] = []
    monitoringResult: string=''
    monitoringResqResult: string=''
    alert: string= ''
}